<template>
  <div :class="$style.reports">
    <projects-report-page
      v-if="type === 'project'"
      :report-type="'budget'"
    />
    <monthes-report-page
      v-if="type === 'month'"
      :report-type="'budget'"
    />
  </div>
</template>

<script>
import monthesReportPage from '../include/monthesReportPage.vue';
import projectsReportPage from '../include/projectsReportPage.vue';

export default {
  components: {
    monthesReportPage, projectsReportPage,
  },
  data() {
    return {
      type: null,
      locales: __,
    };
  },
  mounted() {
    if (['project', 'month'].includes(this.$route.params?.type)) {
      this.type = this.$route.params?.type;

      return;
    }

    this.$router.push({ name: 'reports' });
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
